module.exports = __webpack_public_path__ + "static/media/sub-2.2e233cf5.png";